"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simpleErrorHandler = simpleErrorHandler;
exports.simpleLogger = simpleLogger;
exports.noop = noop;
exports.factoryOptions = void 0;

/**
 * Copyright (c) React Native Community.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const isDevelopment =
// @ts-ignore
process && process.env && process.env.NODE_ENV === 'development' || __DEV__;
const factoryOptions = {
  logger: isDevelopment,
  errorHandler: isDevelopment
};
exports.factoryOptions = factoryOptions;
function simpleErrorHandler(e) {
  let errorMessage = e instanceof Error ? e.message : e;
  console.error(errorMessage);
}
function simpleLogger(logInfo) {
  const log = message => {
    console.log(`[AsyncStorage] ${message}`);
  };
  const {
    action,
    key,
    value
  } = logInfo;
  switch (action) {
    case 'read-single':
      {
        log(`Reading a value for a key: ${key}`);
        break;
      }
    case 'save-single':
      {
        log(`Saving a value: ${value} for a key: ${key}`);
        break;
      }
    case 'delete-single':
      {
        log(`Removing value at a key: ${key}`);
        break;
      }
    case 'read-many':
      {
        log(`Reading values for keys: ${key}`);
        break;
      }
    case 'save-many':
      {
        log(`Saving values ${value} for keys: ${key}`);
        break;
      }
    case 'delete-many':
      {
        log(`Removing multiple values for keys: ${key}`);
        break;
      }
    case 'drop':
      {
        log('Dropping whole database');
        break;
      }
    case 'keys':
      {
        log('Retrieving keys');
        break;
      }
    default:
      {
        log(`Unknown action: ${action}`);
      }
  }
}
function noop() {// noop
}